import React, { FunctionComponent, useCallback } from 'react'

import { Flex, FlexAnchor, FlexProps, mdBumps, Radio, smBumps, Typo } from '../atoms'

export interface OptionTileProps extends FlexProps {
  name: string
  value: boolean | string | number
  text: string
  checked: boolean
  onSelect: (value: boolean | string | number) => void
  disabled?: boolean
}

export const OptionTile: FunctionComponent<OptionTileProps> = ({
  name,
  value,
  text,
  checked,
  onSelect,
  disabled,
  ...props
}) => {
  const onInputChange = useCallback(() => onSelect(value), [value, onSelect])

  const uniqueId = `${name}-${value}`

  return (
    <Flex width={1} py={2} variant='raised' {...props}>
      <FlexAnchor
        as='label'
        htmlFor={uniqueId}
        variant='inset'
        px={mdBumps}
        py={3}
        width={1}
        gap={smBumps}
        justifyContent='flex-start'
        disabled={disabled}
      >
        <Radio
          disabled={disabled}
          name={name}
          id={uniqueId}
          onChange={onInputChange}
          checked={checked}
        />
        <Typo as='span' fontFamily='input' whiteSpace='nowrap'>
          {text}
        </Typo>
      </FlexAnchor>
    </Flex>
  )
}
